import { colors } from '@/constants';
import { BREAKPOINT } from '@/constants/enum';
import styled from 'styled-components';

export const HeatMapStyled = styled.div`
  .card-container {
    .badge-demo {
      margin-left: 8px;
    }
  }
  .heat-map-container {
    display: flex;
    overflow: auto;
  }

  .list-countries {
    width: 40%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .country-item {
      padding: 4px 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: 0.25s all linear;
      cursor: pointer;

      &:hover {
        background-color: ${colors.gray_background};
      }

      .name-country {
        width: 100px;
      }

      .progress-country {
        flex: 1;
      }

      .text-percent {
        width: 40px;
      }
    }
  }

  @media screen and (max-width: ${BREAKPOINT.SM}px) {
    .heat-map-container {
      flex-direction: column;

      .list-countries {
        width: 100%;
      }
    }
  }
`;
